import { AxiosRequestConfig } from 'axios';

import Router from '@/main/router';

import Interceptor from '@/classes/Interceptor';

import baseInterceptor from './base';

import Store from '@/main/store';

const interceptor = (request: AxiosRequestConfig): AxiosRequestConfig => {
  if (!Store.state.App.Behavior.isCaptchaValid) {
    return {};
  }

  const baseRequest: any = baseInterceptor.request && baseInterceptor.request(request);
  return {
    ...baseRequest,
    baseURL: process.env.VUE_APP_MS_COMMERCE_BASE_URL,
    params: {
      ...request.params,
      ...Router.currentRoute.query,
    },
  };
};

export default new Interceptor({ request: interceptor });
